import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Paper from '@mui/material/Paper';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { ListItemButton, Collapse } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { camel2title } from '../utils/stringUtils';
import LogoutIcon from '@mui/icons-material/Logout';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import { withRouter } from 'react-router-dom';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { canAccessResource } from '../utils/permissions';

const drawerWidth = 230;

function handleLogout({ history, setAuth }) {
  localStorage.removeItem('baseUrl');
  localStorage.removeItem('jwtToken');
  localStorage.removeItem('enums');
  localStorage.removeItem('assets');
  history.push('/login');
  setAuth({
    isAuthenticated: false,
    token: '',
    currentUser: {},
  });
}
function DrawerLeft({
  resourcesNavigationGroups,
  resources,
  history,
  auth,
  setAuth,
  setTheme,
}) {
  const [selectedItem, setSelectedItem] = React.useState(
    Object.values(resources)[0].name,
  );

  // function handleSwitchTheme() {
  //   if (!localStorage.theme || localStorage.theme === 'dark') {
  //     localStorage.setItem('theme', 'light');
  //     setTheme('light');
  //   } else {
  //     localStorage.setItem('theme', 'dark');
  //     setTheme('dark');
  //   }
  // }

  function handleCollapseNavigation() {
    for (var i = 0; i < resourcesNavigationGroups.length; i++)
      open[i] = false;
    setOpen({ ...open });
  }

  function handleExpandNavigation() {
    for (var i = 0; i < resourcesNavigationGroups.length; i++)
      open[i] = true;
    setOpen({ ...open });
  }

  const [open, setOpen] = React.useState(
    Object.fromEntries(
      [...Array(resourcesNavigationGroups.length).keys()].map((k, index) => [k, index === 0 ? true : false]),
    ),
  );

  const handleClick = (event) => {
    const index = event.currentTarget.getAttribute('data-menuindex');
    open[index] = !open[index];
    setOpen({ ...open });
  };

  const location = useLocation();
  React.useLayoutEffect(() => {
    const pathname = location.pathname.replace(/\//g, '').replace('login', '');
    setSelectedItem(pathname || Object.values(resources)[0].name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{ width: `calc(100% - ${drawerWidth}px)`, ml: `${drawerWidth}px` }}
      ></AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
        variant="permanent"
        anchor="left"
      >
        <Toolbar style={{ backgroundColor: '#121212' }}>
          <Paper elevation={0} style={{ backgroundColor: 'transparent' }}>
            <a href="/">
              <img src="/LogoOnyzeblanco.png" alt="logo" width="120px" />
            </a>
          </Paper>
        </Toolbar>
        <Divider />
        {/* <Toolbar>
          
        <Divider /> */}
        {Object.values(resourcesNavigationGroups).map(
          (resourcesNavigationGroup, index) => (
            <List>
              <ListItemButton onClick={handleClick} data-menuindex={index}>
                <ListItemText primary={resourcesNavigationGroup.name} />
                {open[index] ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={open[index]} timeout="auto" unmountOnExit>
                <List>
                  {resourcesNavigationGroup.resources.map((resource) => (
                    <RouterLink
                      to={`/${resource.name}`}
                      onClick={() => setSelectedItem(resource.name)}
                      style={{
                        color: 'inherit',
                        textDecoration: 'inherit',
                        display: canAccessResource(auth, resource)
                          ? 'inherit'
                          : 'none',
                      }}
                      key={resource.name}
                    >
                      <ListItem
                        button
                        key={resource.name}
                        sx={{
                          background:
                            resource.name === selectedItem
                              ? 'rgba(72, 75, 75, 0.40)'
                              : 'inherit',
                          color: resource.name === selectedItem ? '#FF8325' : 'inherit'
                        }}
                      >
                        <ListItemText
                          primary={
                            resource.title
                              ? resource.title
                              : `${camel2title(resource.name)}s`
                          }
                          sx={{
                            paddingLeft: '1em'
                          }}
                        />
                      </ListItem>
                    </RouterLink>
                  ))}
                </List>
              </Collapse>
            </List>
          ),
        )}
        <Divider />

        <Toolbar>
          <Tooltip title="Logout">
            <IconButton
              aria-label="logout"
              onClick={() => {
                handleLogout({ history, setAuth });
              }}
            >
              <LogoutIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Collapse All">
            <IconButton
              sx={{marginLeft: 2}}
              aria-label="theme"
              onClick={() => {
                handleCollapseNavigation();
              }}
            >
              <UnfoldLessIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Expand All">
            <IconButton
              sx={{}}
              aria-label="theme"
              onClick={() => {
                handleExpandNavigation();
              }}
            >
              <UnfoldMoreIcon />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </Drawer>
    </Box >
  );
}

export default withRouter(DrawerLeft);
